import React from 'react';
import { useTranslation } from 'react-i18next';
import Rw from './Rw/TermsAndConditions';
import Fr from './Fr/TermsAndConditions';
import En from './En/TermsAndConditions';
import cookies from 'js-cookie';
import './style.css';

const TermsAndConditions = () => {
  const { t } = useTranslation();

  const TermsComponent = () => {
    const lang = cookies.get('i18next');
    if (lang === 'rw') {
      return <Rw />;
    }
    if (lang === 'en') {
      return <En />;
    }
    if (lang === 'fr') {
      return <Fr />;
    }
  };

  return (
    <div className='t_c lh-lg'>
      <div className='page-head-section text-light'>
        <h1 className='text-light'>{t('terms-of-use')}</h1>
        <p className=' sm-label'>
          {t('updated')} {t('february')} 2023
        </p>
      </div>
      <TermsComponent />
    </div>
  );
};

export default TermsAndConditions;
